











































































import { Component, Prop, Vue, Watch } from "vue-property-decorator";
import { Action, Getter } from "vuex-class";

import DoKoDeck from "../components/deck/DoKoDeck.vue";
import DoKoStack from "../components/deck/DoKoStack.vue";
import DoKoLastTrick from "../components/deck/DoKoLastTrick.vue";
import DoKoPlayerInfo from "../components/deck/DoKoPlayerInfo.vue";
import DoKoCurrentTrick from "../components/deck/DoKoCurrentTrick.vue";
import DoKoDialogWaitingForFriends from "../components/dialogs/DoKoDialogWaitingForFriends.vue";
import DoKoBockInfo from "../components/DoKoBockInfo.vue";
import DoKoViewLastTrick from "../components/DoKoViewLastTrick.vue";
import DoKoSpectators from "../components/DoKoSpectators.vue";
import DoKoTableStats from "../components/DoKoTableStats.vue";
import DoKoDialogRestrictions from "../components/dialogs/DoKoDialogRestrictions.vue";
import DoKoDialogPovertyCheck from "../components/dialogs/DoKoDialogPovertyCheck.vue";
import DoKoDialogSpielergebnis from "../components/dialogs/DoKoDialogSpielergebnis.vue";
import DoKoDialogGameMode from "../components/dialogs/DoKoDialogGameMode.vue";
import { api as deskApi } from "../store/modules/desk";
import { Decks } from "../store/modules/desk/types";
import { GameState } from "@dokogd/shared";

@Component({
  components: {
    DoKoDeck,
    DoKoStack,
    DoKoLastTrick,
    DoKoDialogWaitingForFriends,
    DoKoDialogRestrictions,
    DoKoDialogPovertyCheck,
    DoKoPlayerInfo,
    DoKoCurrentTrick,
    DoKoViewLastTrick,
    DoKoSpectators,
    DoKoDialogSpielergebnis,
    DoKoDialogGameMode,
    DoKoBockInfo,
    DoKoTableStats,
  },
})
export default class DoKoDesk extends Vue {
  displayLastTrick = false;
  @Prop({
    type: String,
    required: true,
  })
  deskId!: string;

  @Getter(deskApi.getters.hasAllPlayerJoined, { namespace: deskApi.namespace })
  hasAllPlayerJoined!: boolean;

  @Getter(deskApi.getters.getDecks, { namespace: deskApi.namespace })
  decks!: Decks;

  @Getter(deskApi.getters.isMyTurn, { namespace: deskApi.namespace })
  isMyTurn!: boolean;

  @Getter(deskApi.getters.amIPlayer, { namespace: deskApi.namespace })
  amIPlayer!: boolean;

  @Getter(deskApi.getters.displayGameMode, { namespace: deskApi.namespace })
  displayGameMode!: boolean;

  @Getter(deskApi.getters.getGameState, { namespace: deskApi.namespace })
  gameState!: GameState;

  @Watch("deskId", { immediate: true })
  onDeskChanged(newVal: string, oldVal: string): void {
    console.log("DoKoDesk:onDeskChanged", newVal, oldVal);
    this.listenOnDesk(newVal);
    this.listenForGame(newVal);
  }

  @Action(deskApi.actions.listenOnDesk, { namespace: deskApi.namespace })
  listenOnDesk!: (deskId: string) => Promise<void>;

  @Action(deskApi.actions.stopListenOnDesk, { namespace: deskApi.namespace })
  stopListenOnDesk!: () => Promise<void>;

  @Action(deskApi.actions.listenForGame, { namespace: deskApi.namespace })
  listenForGame!: (deskId: string) => Promise<void>;

  @Action(deskApi.actions.stopListenForGame, { namespace: deskApi.namespace })
  stopListenForGame!: () => Promise<void>;

  created(): void {
    console.log("DoKoDesk:created", this.deskId);
  }

  beforeDestroy(): void {
    console.log("DoKoDesk:beforeDestroy", this.deskId);
    this.stopListenOnDesk();
    this.stopListenForGame();
  }

  get dialogName():
    | typeof DoKoDialogGameMode
    | typeof DoKoDialogRestrictions
    | typeof DoKoDialogPovertyCheck
    | typeof DoKoDialogSpielergebnis
    | null {
    if (this.displayGameMode) {
      return DoKoDialogGameMode;
    } else if (this.gameState === "healthCheck" && this.amIPlayer) {
      return DoKoDialogRestrictions;
    } else if (
      this.isMyTurn &&
      (this.gameState === "povertyCheck" || this.gameState === "returnPoverty")
    ) {
      return DoKoDialogPovertyCheck;
    } else if (this.gameState === "end") {
      return DoKoDialogSpielergebnis;
    } else {
      return null;
    }
  }

  toggleDisplayLastTrick(): void {
    this.displayLastTrick = !this.displayLastTrick;
  }
}
